/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux'
import styles from './SystemLock.module.css';
import { useAuthorizationContext } from '../../providers/AuthorizationHandler/AuthorizationHandler';
import { handleLogout } from "../../utils/utils";

const SystemLockMsg = () => {
  const { user, logoutUser } = useAuthorizationContext();
  const baseUrl = useSelector(state => state.counter.baseUrl);  // useSelector
  const auth = useSelector((state) => state.auth);
  const status = auth?.recentStatus
  const dispatch = useDispatch()
  useEffect(() => {
    if (status === 423) {
      setTimeout(() => {
        handleLogout();
      }, 60000);
    }
  }, [status]);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <div className={styles.background_container} />
      <h2 className={styles.mainTitle}>ERC-Timetracker site is currently Unavailable!</h2>
      <div className={styles.pBlock1}>
        <p>Due to Month end activity, ERC Timebooking System will not be available to end users</p>
        <p>from 11:00 HRS to 23:59 HRS</p>
        <div className={styles.pBlock1}>
          <p>We regret the inconvenience caused!</p>
        </div>
      </div>
      <div className={styles.pBlock1}>
        <p>Thank You!</p>
        <p>Time Tracker Team</p>
      </div>
    </div>
  );
}

export default SystemLockMsg;